import React from 'react';

export const StepSummary = ({ stepNumber, stepTitle, stepInfo, hasTooltip, tooltipText }) => {
  return (
    <div className="step-summary">
      <h6>Step {stepNumber}</h6>
      <div className="title">
        <h2 className="h2-navy-blue">{stepTitle}</h2>
        <i className={`fa fa-info tooltip-container ${hasTooltip ? 'show' : 'hide'}`}>
          <span className="tooltip-text montserrat">
            {tooltipText}
          </span>
        </i>
      </div>
      <p>{stepInfo}</p>
    </div>
  )
}
